<template>
  <!--
  作者：luoyiming
  时间：2019-10-24
  描述：健康资讯
  -->
  <div>
    <!--nav start-->
    <div id="nav">
      <ul class="nav">
        <li :class="routerstr.indexOf('index')!=-1?'active':''" @click="pageClick('/index')">首页</li>
        <li :class="routerstr.indexOf('notice')!=-1?'active':''" @click="pageClick('/notice')">医院通知</li>
        <li :class="routerstr.indexOf('news')!=-1?'active':''" @click="pageClick('/news')">新闻中心</li>
        <li :class="routerstr.indexOf('message')!=-1?'active':''" @click="pageClick('/message')">信息公告</li>
        <li :class="routerstr.indexOf('department')!=-1?'active':''" @click="pageClick('/department')">科室介绍</li>
        <li :class="routerstr.indexOf('information')!=-1?'active':''" @click="pageClick('/information')">健康资讯</li>
        <li :class="routerstr.indexOf('contact')!=-1?'active':''" @click="pageClick('/contact')">联系我们</li>
      </ul>
    </div>
    <!--nav end-->
    <div class="information_detail" v-html="data.content"></div>
    <div class="down" v-if="annexDtoList && annexDtoList.length > 0">
        <p style="font-size: 20px;font-weight: bold;">附件下载
        </p>
        <div style="font-size: 20px;" v-for="(item, index) in annexDtoList" :key="index">
          <p>附件
            <span> {{ index + 1 }} </span> ：
            {{ item.fileName }}
            <a :href="$store.state.targetpath + item.filePath">
              点击下载
            </a>
          </p>

        </div>
      </div>
  </div>
</template>

<script>
  import IndexApi from '@/api/index.js';
  export default {
    data() {
      return {
        annexDtoList:[],
        routerstr:'/information',
        /*是否正在加载*/
        loading: true,
        /*背景图片*/
        bgimg_url: '',
        /*是否正在提交*/
        logining: false,
        /*基础配置*/
        id:0,
        data:{},
      };
    },
    onload(){

    },
    created() {
      const params = this.$route.query;
      this.id = params.id;
      this.getData();
      this.routerstr = this.$router.currentRoute.path;
    },
    methods: {
      /*页面跳转*/
      pageClick(row) {
        this.$router.push(row);
      },
      getData() {
        let self = this;
        var data = {
          healthId:self.id,
        }
        IndexApi.informationdetail(data,true)
          .then(res => {
            self.loading = false;
            self.data = res.data;
            this.annexDtoList=res.data.annexDtoList
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style lang="scss" scoped>
.down{
  width: 1000px;margin: 0 auto;margin-top: 30px;
}
.information_detail{
  width:1610px;margin:23px auto 0;box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.25);padding:40px 50px;font-size:36px;
}
</style>



// WEBPACK FOOTER //
// src/views/informationdetail.vue